module.exports = __webpack_public_path__ + "static/media/sense4060.87ab2e6b.jpg";